import React from 'react';
import Logo from './Logo';
import Button from './Button';

function ErrorFallback({ error, resetError }) {
    return (
        <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
                <Logo center={true} />
                <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                    Something went wrong
                </h2>
                <p className="mt-2 text-sm text-gray-600">
                    An unexpected error occurred. Our team has been notified.
                </p>
                {process.env.NODE_ENV === 'development' && error?.message && (
                    <div className="mt-4 p-4 text-left text-xs bg-red-50 text-red-700 rounded-lg border border-red-200 overflow-x-auto">
                        <p className="font-semibold">{error.name}: {error.message}</p>
                        {error.stack && <pre className="mt-2 text-[10px] whitespace-pre-wrap">{error.stack}</pre>}
                    </div>
                )}
                <div className="mt-6 flex justify-center gap-3">
                    <Button
                        onClick={() => {
                            if (resetError) {
                                resetError();
                            }
                            window.location.href = '/';
                        }}
                    >
                        Return to Home
                    </Button>
                    <Button
                        secondary={true}
                        onClick={() => {
                            if (resetError) {
                                resetError();
                            }
                            window.location.reload();
                        }}
                    >
                        Reload Page
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default ErrorFallback;
